import React from 'react';
import { DCFContextValues } from './types';

const DCFApproachContext = React.createContext<DCFContextValues>({
  panelId: null,
  format: null,
  onChange: null,
  formatDispatch: null,
});

export default DCFApproachContext;
